import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, Button } from '@nextui-org/react';
import { Icon } from '@iconify/react';

export interface FullScreenModalProps {
    isOpen: boolean;
    onClose: () => void;
    agentName: string;
    children: React.ReactNode;
    modalClassName?: string;
    headerBorder?: boolean;
}

export const FullScreenModal: React.FC<FullScreenModalProps> = ({
    isOpen,
    onClose,
    agentName,
    children,
    modalClassName = '',
    headerBorder = false
}) => {
    if (!isOpen) {
        return null;
    }
    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onClose}
            isDismissable={false}
            isKeyboardDismissDisabled={true}
            size="5xl"
            hideCloseButton
            classNames={{
                base: "max-w-[60vw] max-h-[90vh]",
                body: "p-0",
                header: headerBorder ? "border-b border-default-200" : "border-none"
            }}
            scrollBehavior="inside"
        >
            <ModalContent>
                {(onCloseModal) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <div className="flex items-center justify-between w-full">
                                <h2 className="text-xl font-semibold capitalize">{agentName} - Full View</h2>
                                <Button
                                    isIconOnly
                                    variant="light"
                                    onClick={onCloseModal}
                                >
                                    <Icon icon="mdi:close" className="w-5 h-5" />
                                </Button>
                            </div>
                        </ModalHeader>
                        <ModalBody className={modalClassName}>
                            {children}
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

